import { DoubleColor } from '@/__generated__/graphql'
import { GameDouble, GAME } from '@/components/molecules/StyledTable/StyledTable'

export const transformDoubleGames: (data: any, address: string) => GameDouble[] = (data, address) => {
  if (!data) {
    return []
  }

  return data.map(({ node: game }: any) => {
    const bets = {
      [DoubleColor.Black]: game.black,
      [DoubleColor.Red]: game.red,
      [DoubleColor.Green]: game.green,
    } as any

    return {
      id: game.gameId + '-' + game.denom,
      gameId: game.gameId,
      address: address,
      denom: game.denom,
      game: GAME.ROULETTE,
      bets: bets,
      totalBet: game.totalamount,
      winColor: game.wincolor,
      winAmount: Number(game.totalpayout) + (Number(bets[game.wincolor]) || 0),
      jackpotAmount: game.totaljackpot || '0',
    }
  })
}
